import { createActions, createReducer } from 'reduxsauce'

import PagamentosService from '../servicos/PagamentosService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaGruposInicio: [],
    buscaGruposSucesso: ['grupos'],
    buscaGruposErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaGrupos = () => {
    return dispatch => {
        dispatch(Creators.buscaGruposInicio())
        let serv = new PagamentosService()
        return serv
            .getPagamentos()
            .then(response => dispatch(Creators.buscaGruposSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaGruposErro(error)))
    }
}

const buscaGruposInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaGruposErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaGruposSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.grupos, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_GRUPOS_INICIO]: buscaGruposInicio,
    [Types.BUSCA_GRUPOS_ERRO]: buscaGruposErro,
    [Types.BUSCA_GRUPOS_SUCESSO]: buscaGruposSucesso,
})
